/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type setPoshmarkBotDefaultOfferConfigurationMutationVariables = {
  offerConfigId?: string | null;
};
export type setPoshmarkBotDefaultOfferConfigurationMutationResponse = {
  readonly poshmarkSetBotDefaultOfferConfiguration: {
    readonly success: boolean;
  } | null;
};
export type setPoshmarkBotDefaultOfferConfigurationMutation = {
  readonly response: setPoshmarkBotDefaultOfferConfigurationMutationResponse;
  readonly variables: setPoshmarkBotDefaultOfferConfigurationMutationVariables;
};

/*
mutation setPoshmarkBotDefaultOfferConfigurationMutation(
  $offerConfigId: String
) {
  poshmarkSetBotDefaultOfferConfiguration(offerConfigId: $offerConfigId) {
    success
  }
}
*/

const node: ConcreteRequest = (function () {
  var v0 = [
      {
        defaultValue: null,
        kind: 'LocalArgument',
        name: 'offerConfigId',
      },
    ],
    v1 = [
      {
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'offerConfigId',
            variableName: 'offerConfigId',
          },
        ],
        concreteType: 'PoshmarkSetBotDefaultOfferConfigurationResponse',
        kind: 'LinkedField',
        name: 'poshmarkSetBotDefaultOfferConfiguration',
        plural: false,
        selections: [
          {
            alias: null,
            args: null,
            kind: 'ScalarField',
            name: 'success',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ];
  return {
    fragment: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Fragment',
      metadata: null,
      name: 'setPoshmarkBotDefaultOfferConfigurationMutation',
      selections: v1 /*: any*/,
      type: 'Mutation',
      abstractKey: null,
    },
    kind: 'Request',
    operation: {
      argumentDefinitions: v0 /*: any*/,
      kind: 'Operation',
      name: 'setPoshmarkBotDefaultOfferConfigurationMutation',
      selections: v1 /*: any*/,
    },
    params: {
      cacheID: '2837ab260d2c68909787f913fa7535c9',
      id: null,
      metadata: {},
      name: 'setPoshmarkBotDefaultOfferConfigurationMutation',
      operationKind: 'mutation',
      text: 'mutation setPoshmarkBotDefaultOfferConfigurationMutation(\n  $offerConfigId: String\n) {\n  poshmarkSetBotDefaultOfferConfiguration(offerConfigId: $offerConfigId) {\n    success\n  }\n}\n',
    },
  };
})();
(node as any).hash = 'aff1a0e32db8cf05195a71739c285b2e';
export default node;
